module.exports = __webpack_public_path__ + "static/media/style1.d98e2556.gif";